import { memo } from 'react';
import { PhoneIcon, PinIcon } from './icons';
import { initials, telHref } from '../utils/content';
import { getAgentTitle } from '../utils/formatters';

/**
 * FindAgent — "Find an Agent" card grid on agency company webpages: the
 * agency's active agents with photo (monogram fallback), name, title,
 * location, phone, and a link to each agent's own webpage. Collapses when
 * the payload carries no agents.
 */
export const FindAgent = memo(({ agents = [] }) => {
  if (!agents.length) return null;

  return (
    <section className="cw-section section-agents" id="agents">
      <div className="cw-container">
        <header className="section-head reveal">
          <p className="section-eyebrow">Our Team</p>
          <h2 className="section-title">Find an Agent</h2>
          <span className="section-bar" aria-hidden="true" />
        </header>
        <ul className="agent-grid reveal">
          {agents.map(agent => {
            const name = [agent.first_name, agent.last_name].filter(Boolean).join(' ');
            const title = (agent.webpage_title || '').trim() || getAgentTitle(agent.title) || '';
            const location = [agent.city, agent.state].filter(Boolean).join(', ');
            return (
              <li className="agent-card" key={agent.id || name}>
                <span className="agent-photo">
                  {agent.personal_photo_url ? (
                    <img src={agent.personal_photo_url} alt={name} loading="lazy" />
                  ) : (
                    <span className="agent-monogram">{initials(agent.first_name, agent.last_name)}</span>
                  )}
                </span>
                <h3 className="agent-name">{name}</h3>
                {title && <p className="agent-title">{title}</p>}
                {location && (
                  <p className="agent-meta">
                    <PinIcon size={13} />
                    {location}
                  </p>
                )}
                {agent.phone && (
                  <p className="agent-meta">
                    <PhoneIcon size={13} />
                    <a href={telHref(agent.phone)}>{agent.phone}</a>
                  </p>
                )}
                {agent.webpage && (
                  <a
                    className="btn btn-ghost agent-link"
                    href={`//${agent.webpage}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Page
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
});
